import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { LocalStorageProperties } from '../../shared/enums/local-storage-properties.enum';
import localStorageService from '../../shared/services/local-storage/local-storage.service';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';

export const deleteFirmware: AsyncThunk<
  void,
  number,
  Record<string, unknown>
> = createAsyncThunk(
  'firmware/delete-firmware',
  async (firmwareId: number): Promise<void> => {
    const mandantId = localStorageService.get(
      LocalStorageProperties.SELECTED_MANDANT
    ) as string | null;
    const url = createPathParams<'firmwareId' | 'mandantId'>(
      Endpoints.FIRMWARE_BY_ID,
      {
        ...(mandantId !== null && { mandantId: parseInt(mandantId, 10) }),
        firmwareId,
      }
    );
    const { data }: AxiosResponse<void> = await axiosInstance.delete(url);
    return data;
  }
);
